// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.transportation {
  color: white;
  max-width: 550px;
  margin: auto;
  text-align: left;
  display: flex;
  flex-direction: column;
  height: 100%;
}
.transportation h3 {
  margin-top: 4px;
}
.transportation a, .transportation a:visited {
  font-weight: bold;
}
.transportation a:hover {
  color: var(--primary-color);
}
.transportation .journey-container {
  padding: 30px;
}
.transportation .journey-overview {
  margin-top: 10px;
  margin-bottom: 20px;
}
.transportation .plan-header {
  padding-bottom: 5px;
  transition: 0.2s;
  width: 100%;
  background: rgba(40, 40, 40, 0.8);
  box-shadow: 0 0 2px rgba(40, 40, 40, 0.9);
  border-bottom: 2px solid white;
  left: 0;
  top: 0;
  position: absolute;
  top: 100%;
}
.transportation .date-select .time-input input {
  /** Center around center of date **/
  padding-left: 20px;
  width: auto;
  text-align: center;
}
.transportation .plan-header.minify-plan-header {
  transform: translateY(-50%);
  transition: 0.2s;
}
.transportation .minify-plan-header {
  transform: scale(0.5) translateY(50%);
  transition: 0.2s;
}
.transportation .plan-scroll {
  overflow: hidden;
  overflow-y: auto;
  padding: 120px 10px 10px 10px;
}
.transportation .plan {
  opacity: 1;
  transition: 1s;
  width: 100%;
  padding-bottom: 20px;
  padding-left: 10px;
  padding-right: 10px;
  box-sizing: border-box;
  margin-top: 12px;
}
.transportation .plan-loading {
  opacity: 0;
  transition: 2s;
}
.transportation .trans-block {
  display: block;
  white-space: nowrap;
}
.transportation .journey-row {
  display: block;
  line-height: 12px;
}
.transportation .clock-row {
  margin-left: -7px;
  margin-top: 6px;
  margin-bottom: 2px;
}
.transportation .end-row {
  margin-top: 10px;
}
.transportation .journey-icon {
  display: inline-block;
  line-height: 28px;
  vertical-align: top;
  font-size: 28px;
  margin-right: 5px;
  margin-bottom: 2px;
  margin-top: 0px;
}
.transportation .journey-icon-small {
  display: inline-block;
  line-height: 28px;
  margin-right: 8px;
  vertical-align: middle;
}
.transportation .journey-info {
  display: inline-block;
  line-height: 30px;
  white-space: pre-wrap;
  margin-left: 5px;
}
.transportation .origin-name {
  cursor: pointer;
}
.transportation .destination-name {
  cursor: pointer;
  color: var(--motes-gold);
  font-weight: bold;
}
.transportation .ride-details-header {
  cursor: pointer;
}
.transportation .ride-details-header.show {
  font-weight: bold;
}
.transportation .journey-details {
  opacity: 0;
  max-height: 0px;
  overflow: hidden;
  transition: 250ms;
  margin-left: 8px;
}
.transportation .show-journey-details {
  opacity: 1;
  transition: 300ms;
  max-height: 1500px;
}
.transportation .open-icon svg {
  transform: rotate(90deg);
  transition: 300ms;
}
.transportation .loading-indicator {
  position: absolute;
  height: 30px;
  top: 150%;
  left: 50%;
  transform: translateX(-50%);
  vertical-align: middle;
}
.transportation .loading-indicator .journey-info {
  width: 140px;
}
.transportation .loading-icon svg {
  line-height: 30px;
  animation: loading 0.5s infinite linear;
}
.transportation .date-select {
  margin-top: 16px;
}
@keyframes loading {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(359deg);
  }
}
.transportation .color-block {
  border-radius: 3px;
  font-weight: normal;
  padding-left: 6px;
  padding-right: 8px;
}
.transportation .empty-info {
  height: 14px;
}
.transportation .empty-info.WALK {
  height: 6px;
  overflow: hidden;
  position: relative;
  top: -6px;
}
.transportation .color-block {
  font-weight: bold;
  text-shadow: 0 0 1px black;
}
.transportation .BUS, .transportation .EXTRA_BUS, .transportation .TELE_BUS {
  border-left: 2px solid #FCA311;
  padding-left: 16px;
}
.transportation .BUS .color-block, .transportation .EXTRA_BUS .color-block, .transportation .TELE_BUS .color-block {
  background-color: #FCA311;
}
.transportation .METRO, .transportation .TRAIN, .transportation .S_TRAIN, .transportation .IC_TRAIN, .transportation .REG_TRAIN, .transportation .FAST_TRAIN {
  border-left: 2px solid #970d01;
  padding-left: 16px;
}
.transportation .METRO .color-block, .transportation .TRAIN .color-block, .transportation .S_TRAIN .color-block, .transportation .IC_TRAIN .color-block, .transportation .REG_TRAIN .color-block, .transportation .FAST_TRAIN .color-block {
  background-color: #970d01;
}
.transportation .NIGHT_BUS, .transportation .UNKNOWN {
  border-left: 2px solid --motes-blue;
  padding-left: 16px;
}
.transportation .NIGHT_BUS .color-block, .transportation .UNKNOWN .color-block {
  background-color: var(--motes-blue);
}
.transportation .FERRY {
  border-left: 4px dotted #ffffff;
  padding-left: 16px;
}
.transportation .FERRY .color-block {
  background-color: #ffffff;
}
.transportation .WALK {
  border-left: 4px dotted #ffffff;
  padding-left: 16px;
}`, "",{"version":3,"sources":["webpack://./motes-sdk/src/components/transportation/transportation.component.scss"],"names":[],"mappings":"AAAA;EACI,YAAA;EACA,gBAAA;EACA,YAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;AACJ;AACI;EACI,eAAA;AACR;AAEI;EACI,iBAAA;AAAR;AAGI;EACI,2BAAA;AADR;AAII;EACI,aAAA;AAFR;AAKI;EACI,gBAAA;EACA,mBAAA;AAHR;AAMI;EACI,mBAAA;EACA,gBAAA;EACA,WAAA;EACA,iCAAA;EACA,yCAAA;EACA,8BAAA;EACA,OAAA;EACA,MAAA;EACA,kBAAA;EACA,SAAA;AAJR;AAQQ;EACI,mCAAA;EACA,kBAAA;EACA,WAAA;EACA,kBAAA;AANZ;AAUI;EACI,2BAAA;EACA,gBAAA;AARR;AAWI;EACI,qCAAA;EACA,gBAAA;AATR;AAYI;EACI,gBAAA;EACA,gBAAA;EACA,6BAAA;AAVR;AAaI;EACI,UAAA;EACA,cAAA;EACA,WAAA;EACA,oBAAA;EACA,kBAAA;EACA,mBAAA;EACA,sBAAA;EACA,gBAAA;AAXR;AAcI;EACI,UAAA;EACA,cAAA;AAZR;AAeI;EACI,cAAA;EACA,mBAAA;AAbR;AAgBI;EACI,cAAA;EACA,iBAAA;AAdR;AAiBI;EACI,iBAAA;EACA,eAAA;EACA,kBAAA;AAfR;AAkBI;EACI,gBAAA;AAhBR;AAmBI;EACI,qBAAA;EACA,iBAAA;EACA,mBAAA;EACA,eAAA;EAEA,iBAAA;EACA,kBAAA;EACA,eAAA;AAlBR;AAqBI;EACI,qBAAA;EACA,iBAAA;EACA,iBAAA;EACA,sBAAA;AAnBR;AAsBI;EACI,qBAAA;EACA,iBAAA;EACA,qBAAA;EACA,gBAAA;AApBR;AAuBI;EACI,eAAA;AArBR;AAuBI;EACI,eAAA;EACA,wBAAA;EACA,iBAAA;AArBR;AAwBI;EACI,eAAA;AAtBR;AAyBI;EACI,iBAAA;AAvBR;AA0BI;EACI,UAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;AAxBR;AA2BI;EACI,UAAA;EACA,iBAAA;EACA,kBAAA;AAzBR;AA4BI;EACI,wBAAA;EACA,iBAAA;AA1BR;AA6BI;EACI,kBAAA;EACA,YAAA;EACA,SAAA;EACA,SAAA;EACA,2BAAA;EACA,sBAAA;AA3BR;AA6BQ;EACI,YAAA;AA3BZ;AA+BI;EACI,iBAAA;EACA,uCAAA;AA7BR;AAgCI;EACI,gBAAA;AA9BR;AAiCI;EACI;IACI,uBAAA;EA/BV;EAiCM;IACI,yBAAA;EA/BV;AACF;AAkCI;EACI,kBAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;AAhCR;AAmCI;EACI,YAAA;AAjCR;AAqCI;EACI,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,SAAA;AAnCR;AAsCI;EACI,iBAAA;EACA,0BAAA;AApCR;AAuCI;EACI,8BAAA;EACA,kBAAA;AArCR;AAuCQ;EACI,yBAAA;AArCZ;AAyCI;EACI,8BAAA;EACA,kBAAA;AAvCR;AAyCQ;EACI,yBAAA;AAvCZ;AA2CI;EACI,mCAAA;EACA,kBAAA;AAzCR;AA2CQ;EACI,mCAAA;AAzCZ;AA6CI;EACI,+BAAA;EACA,kBAAA;AA3CR;AA6CQ;EACI,yBAAA;AA3CZ;AA+CI;EACI,+BAAA;EACA,kBAAA;AA7CR","sourcesContent":[".transportation {\n    color: white;\n    max-width: 550px;\n    margin: auto;\n    text-align: left;\n    display: flex;\n    flex-direction: column;\n    height: 100%;\n    \n    h3 {\n        margin-top: 4px;\n    }\n    \n    a, a:visited {\n        font-weight: bold;\n    }\n    \n    a:hover {\n        color: var(--primary-color);\n    }\n    \n    .journey-container {\n        padding: 30px;\n    }\n    \n    .journey-overview {\n        margin-top: 10px;\n        margin-bottom: 20px;\n    }\n    \n    .plan-header {\n        padding-bottom: 5px;\n        transition: .2s;\n        width: 100%;\n        background: rgba(40,40,40,.8);\n        box-shadow: 0 0 2px rgba(40,40,40,.9);\n        border-bottom: 2px solid white;\n        left: 0;\n        top: 0;\n        position: absolute;\n        top: 100%;\n    }\n    \n    .date-select .time-input {\n        input {\n            /** Center around center of date **/\n            padding-left: 20px;\n            width: auto;\n            text-align: center;\n        }\n    }\n    \n    .plan-header.minify-plan-header {\n        transform: translateY(-50%);\n        transition: .2s;\n    }\n    \n    .minify-plan-header {\n        transform: scale(.5) translateY(50%);\n        transition: .2s;\n    }\n    \n    .plan-scroll {\n        overflow: hidden;\n        overflow-y: auto;\n        padding: 120px 10px 10px 10px;\n    }\n    \n    .plan {\n        opacity: 1;\n        transition: 1s;\n        width: 100%;\n        padding-bottom: 20px;\n        padding-left: 10px;\n        padding-right: 10px;\n        box-sizing: border-box;\n        margin-top: 12px;\n    }\n    \n    .plan-loading {\n        opacity: 0;\n        transition: 2s;\n    }\n    \n    .trans-block {\n        display: block;\n        white-space: nowrap;\n    }\n    \n    .journey-row {\n        display: block;\n        line-height: 12px;\n    }\n    \n    .clock-row {\n        margin-left: -7px;\n        margin-top: 6px;\n        margin-bottom: 2px;\n    }\n    \n    .end-row {\n        margin-top: 10px;\n    }\n    \n    .journey-icon {\n        display: inline-block;\n        line-height: 28px;\n        vertical-align: top;\n        font-size: 28px;\n        // margin-left: -5px;\n        margin-right: 5px;\n        margin-bottom: 2px;\n        margin-top: 0px;\n    }\n    \n    .journey-icon-small {\n        display: inline-block;\n        line-height: 28px;\n        margin-right: 8px;\n        vertical-align: middle;\n    }\n    \n    .journey-info {\n        display: inline-block;\n        line-height: 30px;\n        white-space:pre-wrap;\n        margin-left: 5px;\n    }\n\n    .origin-name {\n        cursor: pointer;\n    }\n    .destination-name {\n        cursor: pointer;\n        color: var(--motes-gold);\n        font-weight: bold;\n    }\n    \n    .ride-details-header {\n        cursor: pointer;\n    }\n    \n    .ride-details-header.show {\n        font-weight: bold;\n    }\n    \n    .journey-details {\n        opacity: 0;\n        max-height: 0px; \n        overflow: hidden;\n        transition: 250ms;\n        margin-left: 8px;\n    }\n    \n    .show-journey-details {\n        opacity: 1;\n        transition: 300ms;\n        max-height: 1500px; \n    }\n    \n    .open-icon svg {\n        transform: rotate( 90deg);\n        transition: 300ms;\n    }\n    \n    .loading-indicator {\n        position: absolute;\n        height: 30px;\n        top: 150%;\n        left: 50%;\n        transform: translateX(-50%);\n        vertical-align: middle;\n        \n        .journey-info {\n            width: 140px;\n        }\n    }\n    \n    .loading-icon svg {\n        line-height: 30px;\n        animation: loading 0.5s infinite linear;\n    }\n    \n    .date-select {\n        margin-top: 16px;\n    }\n    \n    @keyframes loading {\n        0% {\n            transform: rotate(0deg);\n        }\n        100% {\n            transform: rotate(359deg);\n        }\n    }\n    \n    .color-block {\n        border-radius: 3px;\n        font-weight: normal;\n        padding-left: 6px;\n        padding-right: 8px;\n    } \n    \n    .empty-info {\n        height: 14px;\n    }\n    \n\n    .empty-info.WALK {\n        height: 6px;\n        overflow: hidden;\n        position: relative;\n        top: -6px;\n    }\n    \n    .color-block {\n        font-weight: bold;\n        text-shadow: 0 0 1px black;\n    }\n    \n    .BUS, .EXTRA_BUS, .TELE_BUS {\n        border-left: 2px solid #FCA311;\n        padding-left: 16px;\n        \n        .color-block {\n            background-color: #FCA311;\n        }\n    }\n    \n    .METRO, .TRAIN, .S_TRAIN, .IC_TRAIN, .REG_TRAIN, .FAST_TRAIN {\n        border-left: 2px solid #970d01;\n        padding-left: 16px;\n        \n        .color-block {\n            background-color: #970d01;\n        }\n    }\n    \n    .NIGHT_BUS, .UNKNOWN {\n        border-left: 2px solid --motes-blue;\n        padding-left: 16px;\n        \n        .color-block {\n            background-color: var(--motes-blue)\n        }\n    }\n    \n    .FERRY {\n        border-left: 4px dotted #ffffff;\n        padding-left: 16px;\n\n        .color-block {\n            background-color:  #ffffff;\n        }\n    }\n\n    .WALK {\n        border-left: 4px dotted #ffffff;\n        padding-left: 16px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
